module.exports = __webpack_public_path__ + "static/media/cosmetics.23b11a93.svg";